var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { ButtonBase } from '../../buttons/ButtonBase';
// Color variant specific styles
var MAP_COLOR_VARIANT_TO_STYLES = {
    primary: function (_a) {
        var theme = _a.theme;
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    background-color: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n  "], ["\n    border: 1px solid ", ";\n    background-color: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n  "])), theme.colors.action, theme.colors.action, theme.colors.action);
    },
    secondary: function (_a) {
        var theme = _a.theme;
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    background-color: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n  "], ["\n    border: 1px solid ", ";\n    background-color: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n  "])), theme.colors.secondary, theme.colors.secondary, theme.colors.secondary);
    },
    tertiary: function (_a) {
        var theme = _a.theme;
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border: 1px solid #ddd;\n    background-color: #fff;\n\n    &,\n    &.MuiButton-root.Mui-disabled {\n      color: ", ";\n    }\n\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n      color: #fff;\n    }\n  "], ["\n    border: 1px solid #ddd;\n    background-color: #fff;\n\n    &,\n    &.MuiButton-root.Mui-disabled {\n      color: ", ";\n    }\n\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n      color: #fff;\n    }\n  "])), theme.colors.tertiary, theme.colors.tertiary, theme.colors.tertiary);
    },
};
var ButtonStyled = styled(ButtonBase, {
    shouldForwardProp: function (prop) { return isPropValid(prop) && prop !== 'colorVariant'; },
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  padding: 6px 12px;\n  border-radius: 5px;\n  font-family: ", ";\n  font-weight: 400;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  ", "\n"], ["\n  position: relative;\n  padding: 6px 12px;\n  border-radius: 5px;\n  font-family: ", ";\n  font-weight: 400;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.default;
}, function (_a) {
    var colorVariant = _a.colorVariant;
    return colorVariant ? MAP_COLOR_VARIANT_TO_STYLES[colorVariant] : '';
});
export var Button = function (_a) {
    var _b = _a.colorVariant, colorVariant = _b === void 0 ? 'primary' : _b, btnProps = __rest(_a, ["colorVariant"]);
    return (<ButtonStyled data-testid={"".concat(colorVariant, "-button")} colorVariant={colorVariant} {...btnProps}/>);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
